import { render, staticRenderFns } from "./EmailAndPhoneList.vue?vue&type=template&id=033c9280&scoped=true&"
import script from "./EmailAndPhoneList.vue?vue&type=script&lang=js&"
export * from "./EmailAndPhoneList.vue?vue&type=script&lang=js&"
import style0 from "./EmailAndPhoneList.vue?vue&type=style&index=0&id=033c9280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033c9280",
  null
  
)

export default component.exports